module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "COPYRIGHT"
  }, [_vm._v("© 2014 Chuck DeGroat"), _c('br'), _vm._v("All rights reserved"), _c('br'), _c('br'), _vm._v("Published 2014 by"), _c('br'), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Wm. B. Eerdmans Publishing Co."), _c('br')]), _vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /"), _c('br'), _vm._v("P.O. Box 163, Cambridge "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("cb3 9pu")]), _vm._v(" U.K."), _c('br'), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("DeGroat, Chuck."), _c('br'), _vm._v("Toughest people to love: how to understand, lead, and love the"), _c('br'), _vm._v("difficult people in your life — including yourself / Chuck DeGroat."), _c('br'), _vm._v("pages   cm"), _c('br'), _vm._v("  Includes bibliographical references."), _c('br'), _vm._v("  ISBN 978-0-8028-7143-5 (pbk.: alk. paper)"), _c('br'), _vm._v("  eISBN 978-1-4674-4040-0 (ePub)"), _c('br'), _vm._v("  eISBN 978-1-4674-3998-5 (Kindle)"), _c('br'), _vm._v("1. Conflict management — Religious aspects — Christianity."), _c('br'), _vm._v("2. Interpersonal conflict — Religious aspects — Christianity."), _c('br'), _vm._v("3. Interpersonal relations — Religious aspects — Christianity."), _c('br'), _vm._v("4. Love — Religious aspects — Christianity. I. Title."), _c('br'), _c('br'), _vm._v("BV4597.53.C58D44 2014"), _c('br'), _vm._v("248.4 — dc23"), _c('br'), _vm._v("              2014002440")]), _vm._v(" "), _c('p', {
    staticClass: "CIP para-style-override-1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-273528bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 60
// module chunks = 0